export default class Popup {
	constructor() {
		this.node = document.querySelectorAll('.trigger-popup');

		if (!this.node) {
			return;
		}

		document.addEventListener('click', (e) => {
			if (e.target.closest('.trigger-popup')) {
				let ee = e;
				const trigger = document.querySelectorAll('.trigger-popup');
				trigger.forEach((node) => {
					node.closest('.popup').classList[ ee.target.closest('.trigger-popup') == node ? 'toggle' : 'remove' ]('open')
				});
			} else {
				document.querySelectorAll('.trigger-popup').forEach((node) => node.closest('.popup').classList.remove('open'));
			}
		});
	}
}

